import React, { memo } from "react";
import { Form, Upload, Icon } from "antd";

import Attachment from "../../attachments/attachment";
import {
	getVotingFile,
	getVotingFilePreview,
} from "../../../store/thunks/get-file";

const File = memo(({ getFieldDecorator, setFieldsValue, votingId, file }) => {
	const fileList =
		file?.fileList.map((file, index) => {
			if (file.uid) {
				return file;
			} else {
				return { ...file, uid: index };
			}
		}) || [];

	return (
		<Form.Item>
			{getFieldDecorator("file")(
				<Upload.Dragger
					className="file-dragger"
					beforeUpload={() => {
						return false;
					}}
					showUploadList={false}
					multiple
					fileList={fileList}
				>
					<p className="ant-upload-text" style={{ padding: "16px 0" }}>
						<Icon type="file-add" className="file-add-icon" />
						<span>перетащите файлы сюда или нажмите, чтобы выбрать</span>
					</p>
				</Upload.Dragger>
			)}
			{fileList.length > 0 && (
				<div className="attachments">
					{fileList.map((file, index) => {
						return (
							<Attachment
								getFile={() => {
									return getVotingFile(votingId, file.fileName);
								}}
								key={index}
								uploadedFileText={file.name}
								onDelete={() => {
									setFieldsValue({
										file: {
											file: undefined,
											fileList: [
												...fileList.filter((attach) => attach.uid !== file.uid),
											],
										},
									});
								}}
								loadPreview={() => {
									return getVotingFilePreview(votingId, file.fileName);
								}}
							/>
						);
					})}
				</div>
			)}
		</Form.Item>
	);
});

export default File;
